export const ADD_PROPAGATION_ACTION = "UI/EDITOR_ACTION_PROPAGATION/ADD";
export const REMOVE_PROPAGATION_ACTION = "UI/EDITOR_ACTION_PROPAGATION/REMOVE";
export const SET_PROPAGATION_PROCESSING =
  "UI/EDITOR_ACTION_PROPAGATION/SET_IS_PROCESSING";
export const SET_PROPAGATING_DESIGN_IDS =
  "UI/EDITOR_ACTION_PROPAGATION/SET_PROPAGATING_DESIGN_IDS";
export const REMOVE_PROPAGATING_DESIGN_ID =
  "UI/EDITOR_ACTION_PROPAGATION/REMOVE_PROPAGATING_DESIGN_ID";
